import { Component, Entity2D } from '../../../odie';
import { ColorId } from '../../defs/block';
import {
  FlowerFidgetBlockProps,
  FlowerFidgetState,
  FlowerFidgetColor,
  flowerFidgetColors,
  flowerFidgetOptionToState,
  flowerFidgetStateToOption,
} from './FlowerFidgetBlock';
import { FlowerFidgetBlockView } from './FlowerFidgetBlockView';

export type FlowerFidgetBlockComponentOptions = {
  props: FlowerFidgetBlockProps;
  option?: number;
};

export class FlowerFidgetBlockComponent implements Component {
  public static readonly NAME = 'blockFlowerFidget';
  public entity!: Entity2D;
  public view!: FlowerFidgetBlockView;
  private props!: FlowerFidgetBlockProps;
  private state!: FlowerFidgetState;

  public init(args: FlowerFidgetBlockComponentOptions): void {
    this.props = args.props;
    this.view = new FlowerFidgetBlockView(args.props);
    this.state = flowerFidgetOptionToState(args.option ?? 0);
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
    this.view.updateColors(this.state);
  }

  public getGameplayState(): number {
    return flowerFidgetStateToOption(this.state);
  }

  public hitColor(color: ColorId) {
    const colorState = color as FlowerFidgetColor;

    // Flower Fidget only gets hit by its designated colors
    if (!flowerFidgetColors.includes(colorState)) return false;

    // If color is already hit, return false
    if (this.state[colorState]) return false;

    // Mark the color as hit
    this.state[colorState] = true;

    // Update the view with the new state
    this.view.updateColors(this.state);

    // Return true if the hit was effective
    return true;
  }

  public getState() {
    return this.state;
  }
}
